import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';
import { UserAddressVm, UserAddressVmFromFg } from '../../Administration/Models/User/UserAddressVm';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditUserVm {
	userId: number;
	firstName?: string;
	lastName?: string;
	userName?: string;
	phoneNumber?: string;
	email?: string;
	isActive: boolean;
	isActiveStr?: string;
	isLockedOut: boolean;
	isLockedOutStr?: string;
	friendlyId?: string;
	address?: UserAddressVm;
	addressFull?: string;
	domicileId?: number;
	domicile?: string;
	activeStatus?: string;
	role?: string;
	isTeamLead?: string;
	name?: string;
	experienceLevel?: string;
	isW9Received?: string;
	isExemptionFormReceived?: string;
	isResponseTrained?: string;
	toursOfDuty: number;
	employeeType?: string;
	driversLicenseClass?: string;
	hasHazMat?: string;
	lastWebLogin?: string;
	lastWebLoginDt?: Date;
	lastMobileLogin?: string;
	lastMobileLoginDt?: Date;
	isUpdatedOffline: boolean;
	permissionId?: number;
	permission?: string;
	permissionProfile?: string;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'firstName': new UntypedFormControl(null, [...(validators['firstName'] ?? []), ...[Validators.required, Validators.maxLength(20)]]),
			'lastName': new UntypedFormControl(null, [...(validators['lastName'] ?? []), ...[Validators.required, Validators.maxLength(20)]]),
			'userName': new UntypedFormControl(null, [...(validators['userName'] ?? []), ...[Validators.required, Validators.minLength(5), Validators.maxLength(50), Validators.pattern("^[A-Za-z0-9.@-_']+$")]]),
			'phoneNumber': new UntypedFormControl(null, [...(validators['phoneNumber'] ?? []), ...[Validators.required]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[Validators.required, Validators.email, Validators.maxLength(40)]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'isActiveStr': new UntypedFormControl(null, [...(validators['isActiveStr'] ?? []), ...[]]),
			'isLockedOut': new UntypedFormControl(false, [...(validators['isLockedOut'] ?? []), ...[]]),
			'isLockedOutStr': new UntypedFormControl(null, [...(validators['isLockedOutStr'] ?? []), ...[]]),
			'friendlyId': new UntypedFormControl(null, [...(validators['friendlyId'] ?? []), ...[]]),
			'address': UserAddressVm.Form,
			'addressFull': new UntypedFormControl(null, [...(validators['addressFull'] ?? []), ...[]]),
			'domicileId': new UntypedFormControl(null, [...(validators['domicileId'] ?? []), ...[]]),
			'domicile': new UntypedFormControl(null, [...(validators['domicile'] ?? []), ...[]]),
			'activeStatus': new UntypedFormControl(null, [...(validators['activeStatus'] ?? []), ...[]]),
			'role': new UntypedFormControl(null, [...(validators['role'] ?? []), ...[]]),
			'isTeamLead': new UntypedFormControl(null, [...(validators['isTeamLead'] ?? []), ...[]]),
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[]]),
			'experienceLevel': new UntypedFormControl(null, [...(validators['experienceLevel'] ?? []), ...[]]),
			'isW9Received': new UntypedFormControl(null, [...(validators['isW9Received'] ?? []), ...[]]),
			'isExemptionFormReceived': new UntypedFormControl(null, [...(validators['isExemptionFormReceived'] ?? []), ...[]]),
			'isResponseTrained': new UntypedFormControl(null, [...(validators['isResponseTrained'] ?? []), ...[]]),
			'toursOfDuty': new UntypedFormControl(0, [...(validators['toursOfDuty'] ?? []), ...[Validators.required]]),
			'employeeType': new UntypedFormControl(null, [...(validators['employeeType'] ?? []), ...[]]),
			'driversLicenseClass': new UntypedFormControl(null, [...(validators['driversLicenseClass'] ?? []), ...[]]),
			'hasHazMat': new UntypedFormControl(null, [...(validators['hasHazMat'] ?? []), ...[]]),
			'lastWebLogin': new UntypedFormControl(null, [...(validators['lastWebLogin'] ?? []), ...[]]),
			'lastWebLoginDt': new UntypedFormControl(null, [...(validators['lastWebLoginDt'] ?? []), ...[]]),
			'lastMobileLogin': new UntypedFormControl(null, [...(validators['lastMobileLogin'] ?? []), ...[]]),
			'lastMobileLoginDt': new UntypedFormControl(null, [...(validators['lastMobileLoginDt'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'permissionId': new UntypedFormControl(null, [...(validators['permissionId'] ?? []), ...[Validators.required]]),
			'permission': new UntypedFormControl(null, [...(validators['permission'] ?? []), ...[]]),
			'permissionProfile': new UntypedFormControl(null, [...(validators['permissionProfile'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['activeStatus', {"orderId":0,"sortColumn":"activeStatus","searchColumn":"activeStatus","includeInExcel":true,"exportColumn":null,"displayName":"Status","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['name', {"orderId":1,"sortColumn":"name","searchColumn":"name","includeInExcel":true,"exportColumn":null,"displayName":"Name","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['role', {"orderId":2,"sortColumn":"role","searchColumn":"role","includeInExcel":true,"exportColumn":null,"displayName":"Role","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['isTeamLead', {"orderId":3,"sortColumn":"isTeamLead","searchColumn":"isTeamLead","includeInExcel":true,"exportColumn":null,"displayName":"Lead?","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['phoneNumber', {"orderId":4,"sortColumn":"phoneNumber","searchColumn":"phoneNumber","includeInExcel":true,"exportColumn":null,"displayName":"Phone Number","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['email', {"orderId":5,"sortColumn":"email","searchColumn":"email","includeInExcel":true,"exportColumn":null,"displayName":"Email","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['experienceLevel', {"orderId":6,"sortColumn":"experienceLevel","searchColumn":"experienceLevel","includeInExcel":true,"exportColumn":null,"displayName":"Experience","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['isW9Received', {"orderId":7,"sortColumn":"isW9Received","searchColumn":"isW9Received","includeInExcel":true,"exportColumn":null,"displayName":"W-9 Received?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['isExemptionFormReceived', {"orderId":8,"sortColumn":"isExemptionFormReceived","searchColumn":"isExemptionFormReceived","includeInExcel":true,"exportColumn":null,"displayName":"Exemption Form Received?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['isResponseTrained', {"orderId":9,"sortColumn":"isResponseTrained","searchColumn":"isResponseTrained","includeInExcel":true,"exportColumn":null,"displayName":"Response Trained?","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['toursOfDuty', {"orderId":10,"sortColumn":"toursOfDuty","searchColumn":"toursOfDuty","includeInExcel":true,"exportColumn":null,"displayName":"Tours of Duty","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['employeeType', {"orderId":11,"sortColumn":"employeeType","searchColumn":"employeeType","includeInExcel":true,"exportColumn":null,"displayName":"Employee Type","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['driversLicenseClass', {"orderId":12,"sortColumn":"driversLicenseClass","searchColumn":"driversLicenseClass","includeInExcel":true,"exportColumn":null,"displayName":"DL Class?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['hasHazMat', {"orderId":13,"sortColumn":"hasHazMat","searchColumn":"hasHazMat","includeInExcel":true,"exportColumn":null,"displayName":"HazMat?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['lastWebLoginDt', {"orderId":14,"sortColumn":"lastWebLoginDt","searchColumn":"lastWebLoginDt","includeInExcel":true,"exportColumn":null,"displayName":"Last Web Login","isVisible":false,"canSearch":false,"multiSearchCellClasses":null}],
			['lastMobileLoginDt', {"orderId":15,"sortColumn":"lastMobileLoginDt","searchColumn":"lastMobileLoginDt","includeInExcel":true,"exportColumn":null,"displayName":"Last Mobile Login","isVisible":false,"canSearch":false,"multiSearchCellClasses":null}],
			['isLockedOutStr', {"orderId":16,"sortColumn":"isLockedOutStr","searchColumn":"isLockedOutStr","includeInExcel":true,"exportColumn":null,"displayName":"Is Locked Out?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['permissionProfile', {"orderId":17,"sortColumn":"permissionProfile","searchColumn":"permissionProfile","includeInExcel":true,"exportColumn":null,"displayName":"Permission","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['isActiveStr', {"orderId":18,"sortColumn":"isActiveStr","searchColumn":"isActiveStr","includeInExcel":true,"exportColumn":null,"displayName":"Is Active?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":19,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":false,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): EditUserVmFromFg {
		return new EditUserVmFromFg(fg);
	}
}

export class EditUserVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get firstName(): string {
		return this.fg.get('firstName').value;
	}
	set firstName(val) {
		this.fg.get('firstName').setValue(val);
	}

	get lastName(): string {
		return this.fg.get('lastName').value;
	}
	set lastName(val) {
		this.fg.get('lastName').setValue(val);
	}

	get userName(): string {
		return this.fg.get('userName').value;
	}
	set userName(val) {
		this.fg.get('userName').setValue(val);
	}

	get phoneNumber(): string {
		return this.fg.get('phoneNumber').value;
	}
	set phoneNumber(val) {
		this.fg.get('phoneNumber').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get isActiveStr(): string {
		return this.fg.get('isActiveStr').value;
	}
	set isActiveStr(val) {
		this.fg.get('isActiveStr').setValue(val);
	}

	get isLockedOut(): boolean {
		return this.fg.get('isLockedOut').value;
	}
	set isLockedOut(val) {
		this.fg.get('isLockedOut').setValue(val);
	}

	get isLockedOutStr(): string {
		return this.fg.get('isLockedOutStr').value;
	}
	set isLockedOutStr(val) {
		this.fg.get('isLockedOutStr').setValue(val);
	}

	get friendlyId(): string {
		return this.fg.get('friendlyId').value;
	}
	set friendlyId(val) {
		this.fg.get('friendlyId').setValue(val);
	}

	get address(): UserAddressVmFromFg {
		return new UserAddressVmFromFg(this.fg.get('address') as UntypedFormGroup);
	}
	set address(val) {
		(this.fg.get('address') as UntypedFormGroup).setValue(val);
	}

	get addressFull(): string {
		return this.fg.get('addressFull').value;
	}
	set addressFull(val) {
		this.fg.get('addressFull').setValue(val);
	}

	get domicileId(): number {
		return this.fg.get('domicileId').value;
	}
	set domicileId(val) {
		this.fg.get('domicileId').setValue(val);
	}

	get domicile(): string {
		return this.fg.get('domicile').value;
	}
	set domicile(val) {
		this.fg.get('domicile').setValue(val);
	}

	get activeStatus(): string {
		return this.fg.get('activeStatus').value;
	}
	set activeStatus(val) {
		this.fg.get('activeStatus').setValue(val);
	}

	get role(): string {
		return this.fg.get('role').value;
	}
	set role(val) {
		this.fg.get('role').setValue(val);
	}

	get isTeamLead(): string {
		return this.fg.get('isTeamLead').value;
	}
	set isTeamLead(val) {
		this.fg.get('isTeamLead').setValue(val);
	}

	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}

	get experienceLevel(): string {
		return this.fg.get('experienceLevel').value;
	}
	set experienceLevel(val) {
		this.fg.get('experienceLevel').setValue(val);
	}

	get isW9Received(): string {
		return this.fg.get('isW9Received').value;
	}
	set isW9Received(val) {
		this.fg.get('isW9Received').setValue(val);
	}

	get isExemptionFormReceived(): string {
		return this.fg.get('isExemptionFormReceived').value;
	}
	set isExemptionFormReceived(val) {
		this.fg.get('isExemptionFormReceived').setValue(val);
	}

	get isResponseTrained(): string {
		return this.fg.get('isResponseTrained').value;
	}
	set isResponseTrained(val) {
		this.fg.get('isResponseTrained').setValue(val);
	}

	get toursOfDuty(): number {
		return this.fg.get('toursOfDuty').value;
	}
	set toursOfDuty(val) {
		this.fg.get('toursOfDuty').setValue(val);
	}

	get employeeType(): string {
		return this.fg.get('employeeType').value;
	}
	set employeeType(val) {
		this.fg.get('employeeType').setValue(val);
	}

	get driversLicenseClass(): string {
		return this.fg.get('driversLicenseClass').value;
	}
	set driversLicenseClass(val) {
		this.fg.get('driversLicenseClass').setValue(val);
	}

	get hasHazMat(): string {
		return this.fg.get('hasHazMat').value;
	}
	set hasHazMat(val) {
		this.fg.get('hasHazMat').setValue(val);
	}

	get lastWebLogin(): string {
		return this.fg.get('lastWebLogin').value;
	}
	set lastWebLogin(val) {
		this.fg.get('lastWebLogin').setValue(val);
	}

	get lastWebLoginDt(): Date {
		return this.fg.get('lastWebLoginDt').value;
	}
	set lastWebLoginDt(val) {
		this.fg.get('lastWebLoginDt').setValue(val);
	}

	get lastMobileLogin(): string {
		return this.fg.get('lastMobileLogin').value;
	}
	set lastMobileLogin(val) {
		this.fg.get('lastMobileLogin').setValue(val);
	}

	get lastMobileLoginDt(): Date {
		return this.fg.get('lastMobileLoginDt').value;
	}
	set lastMobileLoginDt(val) {
		this.fg.get('lastMobileLoginDt').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get permissionId(): number {
		return this.fg.get('permissionId').value;
	}
	set permissionId(val) {
		this.fg.get('permissionId').setValue(val);
	}

	get permission(): string {
		return this.fg.get('permission').value;
	}
	set permission(val) {
		this.fg.get('permission').setValue(val);
	}

	get permissionProfile(): string {
		return this.fg.get('permissionProfile').value;
	}
	set permissionProfile(val) {
		this.fg.get('permissionProfile').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
